import { registerMutation, registerQuery } from '@adornis/baseql/metadata/register.js';
import { getContext } from '@adornis/baseql/server/context.js';
import { config } from '../config.js';
import { type AuthenticationContext, isAuthenticatedContext, isAdministrator } from '../server/auth.js';
import { readForwardingTarget, saveForwardingTarget } from '../server/call-forwarding-settings.js';

function forwardingUser() {
  const context = getContext() as AuthenticationContext | undefined;
  if (!context || context.serverContext || typeof context.userID !== 'string' || !isAuthenticatedContext(context))
    throw new Error('FORWARDING_AUTH_REQUIRED');
  return context;
}
async function forwardingStatus(context: AuthenticationContext) {
  return JSON.stringify({
    ...(await readForwardingTarget(config.get('TWILIO_REDIRECT_NUMBER'))),
    canEdit: isAdministrator(context),
  });
}
export const getCallForwardingSettings = registerQuery({
  type: () => String,
  operationName: 'getCallForwardingSettings',
  resolve: () => async () => forwardingStatus(forwardingUser()),
  params: [],
});
export const saveCallForwardingNumber = registerMutation({
  type: () => String,
  operationName: 'saveCallForwardingNumber',
  resolve: (number: string) => async () => {
    const context = forwardingUser();
    if (!isAdministrator(context)) throw new Error('FORWARDING_ADMIN_REQUIRED');
    await saveForwardingTarget(number, context.userID as string);
    return forwardingStatus(context);
  },
  params: [{ name: 'number', type: () => String }],
});
